import { gql } from '@apollo/client';

export * from './reinitOauthIntegrationAuth.mutation.generated';

export const REINIT_OAUTH_INTEGRATION_AUTH = gql`
  mutation reinitOauthIntegrationAuth($integrationId: ID!) {
    reinitOauthIntegrationAuth(input: { integrationId: $integrationId }) {
      success
      errors
      integrationAuth {
        url
        stateToken
      }
    }
  }
`;
